import axios from "axios";

export default axios.create({
    baseURL: 'https://netreach.app:443'
    // baseURL: 'http://localhost:80'
});